import useSWR from "swr";
import { fetcher } from "../lib/api";
import type { CellFeatureCollection } from "../types/cell";

export function useCells(tickId: string | null) {
  const key = tickId ? `/cells?tick_id=${encodeURIComponent(tickId)}` : null;
  const { data, error, isLoading } = useSWR<CellFeatureCollection>(key, fetcher);
  return { geojson: data, isLoading, error };
}
